// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2YHs5","notes":"Notes_notes__3wASL"};